module.exports = "<div class=form-control> <div class=dropdown></div> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/form/select-control/select-control.wx.html
// module id = 1948
// module chunks = 50